const FeatureDetail = (toggles) => {
  const detailClass = 'feature-detail';
  const detailOpenClass = 'open';
  const detailOpenBodyClass = 'detail-open';
  const noScrollClass = 'no-scroll';

  toggles.forEach(toggle => toggle.addEventListener('click', toggleDetail));

  function handleTransitionend() {
    document.documentElement.classList.remove(noScrollClass);
    document.body.classList.remove(detailOpenBodyClass);
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      const openDetail = document.querySelector(`.${detailClass}.${detailOpenClass}`);
      openDetail.classList.remove(detailOpenClass);
      openDetail.addEventListener('transitionend', handleTransitionend, { once: true });
    }
  }

  function toggleDetail(e) {
    const toggle = e.currentTarget;
    const id = toggle.dataset.detailToggle;
    const detail = document.querySelector(`[data-detail-id="${id}"]`);
    const isOpen = detail.classList.contains('open');

    if (isOpen) {
      detail.addEventListener('transitionend', handleTransitionend, { once: true });
    } else {
      document.documentElement.classList.add(noScrollClass);
      document.body.classList.add(detailOpenBodyClass);
    }

    document.addEventListener('keydown', handleKeydown, { once: true });

    detail.classList.toggle(detailOpenClass, !isOpen);
  }
}

export default FeatureDetail;
